import React from "react";
import { ConfirmDialog } from "primereact/confirmdialog";
import type { PayoutConfirm } from "../hooks/useThgPayoutActions";
import { formatEur } from "../utils/thgFormat";
import { PAYOUT_COPY } from "../ThgAnnualSummary.consts";

interface PayoutConfirmDialogProps {
  year: number;
  confirm: PayoutConfirm;
  onAccept: () => void;
  onCancel: () => void;
}

/**
 * Confirms generating a draft credit note: it creates an accounting document, so it never happens on a single
 * click. Nothing is sent to the owner; the draft is finalised and sent in the accounting system.
 *
 * Mounted only while a confirmation is open, and always visible while mounted. A ConfirmDialog kept mounted
 * calls `onHide` from its effect whenever `visible` is false, which could cancel a confirmation opened in the
 * same tick; mounting it with the confirmation avoids that. The global `confirmDialog()` bus is not used: it
 * only reaches a dialog that has already subscribed.
 */
const PayoutConfirmDialog: React.FC<PayoutConfirmDialogProps> = ({ year, confirm, onAccept, onCancel }) => {
  const { row } = confirm;
  return (
    <ConfirmDialog
      visible
      onHide={onCancel}
      header={PAYOUT_COPY.generateHeader(row.stationId)}
      icon="pi pi-file-edit"
      message={PAYOUT_COPY.generateConfirm(
        row.stationId,
        year,
        row.owner?.name ?? PAYOUT_COPY.unknownRecipient,
        formatEur(row.payoutEur),
      )}
      acceptLabel="Generate draft"
      rejectLabel="Cancel"
      accept={onAccept}
      reject={onCancel}
      style={{ width: "34rem" }}
    />
  );
};

export default PayoutConfirmDialog;
